/**
 * Color constants for map markers and routes
 */

// Technician route colors for multi-technician views
export const TECHNICIAN_COLORS = [
  '#3b82f6', // blue-500
  '#ef4444', // red-500
  '#10b981', // green-500
  '#f59e0b', // amber-500
  '#8b5cf6', // violet-500
  '#ec4899', // pink-500
  '#14b8a6', // teal-500
  '#f97316', // orange-500
] as const;

// Workorder status colors for markers (future use)
export const STATUS_COLORS = {
  scheduled: '#3b82f6', // blue-500
  in_progress: '#f59e0b', // amber-500
  completed: '#10b981', // green-500
} as const;

// HQ marker color
export const HQ_COLOR = '#f59e0b'; // amber-500

// Default route color (single technician view)
export const DEFAULT_ROUTE_COLOR = '#3b82f6'; // blue-500

// Default marker background color
export const DEFAULT_MARKER_BG = '#18181b'; // zinc-900
